import { InputField } from '@components/forms/InputField'
import { SelectButton } from '@features/profile/components/SelectButton'
import { AddressSearchSelectField } from '@components/forms/AddressSearchSelectField'
import { TextAreaField } from '@components/forms/TextAreaField'
import { SelectSearchField } from '@components/forms/SelectSearchField'
import { Checkbox } from '@components/forms/Checkbox'
import { WriterEnum } from '@interfaces/WriterEnum'
import { ResidenceEnum } from '@interfaces/ResidenceEnum'
import { DeliveryAddressProps } from './interface'

export function DeliveryAddress({
  values,
  residenceOptions,
  countryOptions,
  handleAddressChange,
}: DeliveryAddressProps) {
  return (
    <div>
      <h2 className='font-mitr text-[24px] ladding-[1.5] font-medium text-secondary dark:text-dark-10'>
        ที่อยู่สำหรับจัดส่งเอกสาร
      </h2>
      <Checkbox
        className='mt-[20px] mobile:mt-[10px]'
        name='isSameMainAddress'
        label={
          <span className='text-[14px] text-secondary dark:text-dark-10 font-light'>
            {values.type === WriterEnum.INDIVIDUAL
              ? 'ใช้ที่อยู่ตามบัตรประชาชน'
              : 'ใช้ที่อยู่ตามหนังสือรับรอง'}
          </span>
        }
      />
      {!values.isSameMainAddress && (
        <div className='grid grid-cols-3 tablet:grid-cols-2 mobile:grid-cols-1 gap-[20px] mt-[20px] mobile:mt-[20px]'>
          <SelectButton
            name='sendResidence'
            label='ประเทศ'
            options={residenceOptions}
          />
          {values.sendResidence === ResidenceEnum.LOCAL ? (
            <>
              <InputField
                name='sendAddress'
                label='ที่อยู่'
                placeholder='รายละเอียดที่อยู่ เช่น บ้านเลขที่, ตึก, อาคาร, ซอย, หมู่ที่'
                showErrorMsg={false}
              />
              <AddressSearchSelectField
                name='sendPostcode'
                label='รหัสไปรษณีย์'
                addressKey='zipcode'
                placeholder='รหัสไปรษณีย์'
                onChange={handleAddressChange}
              />
              <AddressSearchSelectField
                name='sendProvince'
                label='จังหวัด'
                addressKey='province'
                placeholder='จังหวัด'
                onChange={handleAddressChange}
              />
              <AddressSearchSelectField
                name='sendDistrict'
                label='เขต / อำเภอ'
                addressKey='amphoe'
                placeholder='เขต / อำเภอ'
                onChange={handleAddressChange}
              />
              <AddressSearchSelectField
                name='sendSubDistrict'
                label='แขวง / ตำบล'
                addressKey='district'
                placeholder='แขวง / ตำบล'
                onChange={handleAddressChange}
              />
            </>
          ) : (
            <>
              <SelectSearchField
                name='sendCountry'
                label='ประเทศ'
                placeholder='เลือกประเทศ'
                options={countryOptions}
              />
              <InputField
                name='aboardSendPostcode'
                label='รหัสไปรษณีย์'
                placeholder='รหัสไปรษณีย์'
                showErrorMsg={false}
              />
              <TextAreaField
                className='col-span-3 tablet-mobile:col-span-1'
                textAreaClassName='min-h-[120px]'
                name='aboardSendAddress'
                label='ที่อยู่'
                placeholder='รายละเอียดที่อยู่ เช่น บ้านเลขที่, ตึก, อาคาร, ซอย, หมู่ที่'
              />
            </>
          )}
        </div>
      )}
    </div>
  )
}
